export const DROPDOWN_CLOSED = '__BO_DROPDOWN_CLOSED__';
